__turbopack_context__.v({
  "actions": "CompanyProfileNudge-module-scss-module__UPLPUW__actions",
  "button": "CompanyProfileNudge-module-scss-module__UPLPUW__button",
  "dismiss": "CompanyProfileNudge-module-scss-module__UPLPUW__dismiss",
  "icon": "CompanyProfileNudge-module-scss-module__UPLPUW__icon",
  "nudge": "CompanyProfileNudge-module-scss-module__UPLPUW__nudge",
  "nudgeOpen": "CompanyProfileNudge-module-scss-module__UPLPUW__nudgeOpen",
  "switcher": "CompanyProfileNudge-module-scss-module__UPLPUW__switcher",
  "text": "CompanyProfileNudge-module-scss-module__UPLPUW__text",
});
